import { render, staticRenderFns } from "./AccUnbundling.vue?vue&type=template&id=3c3742a4&scoped=true"
import script from "./AccUnbundling.vue?vue&type=script&lang=js"
export * from "./AccUnbundling.vue?vue&type=script&lang=js"
import style0 from "./AccUnbundling.vue?vue&type=style&index=0&id=3c3742a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3742a4",
  null
  
)

export default component.exports